<h2 class="scorecard-title">
  {{ scorecard.scorecardName }}
  {{ scorecard.scoreAchieved }}/{{ scorecard.totalPossiblePoints }}
  ({{ scorecard.scoreAchieved | scorecardPercentage: scorecard.totalPossiblePoints }}%)
</h2>

<h2 class="scorecard-title"> Scorecard Details </h2>

<div class="scorecard-details">
  <div>
    <h6 class="scorecard-details__label">Employee</h6>
    <span class="scorecard-details__value">{{ scorecard.agentName }}</span>
  </div>
  <div>
    <h6 class="scorecard-details__label">Communication ID</h6>
    <span class="scorecard-details__value">{{ scorecard.conversationId }}</span>
  </div>
  <div>
    <h6 class="scorecard-details__label">Account</h6>
    <span class="scorecard-details__value">{{ scorecard.accountName }}</span>
  </div>
  <div>
    <h6 class="scorecard-details__label">Site</h6>
    <span class="scorecard-details__value">{{ scorecard.siteName }}</span>
  </div>
  <div>
    <h6 class="scorecard-details__label">Start Time</h6>
    <span class="scorecard-details__value">{{ scorecard.startDate | date: 'M/d/yyyy h:mm a' }}</span>
  </div>
  <div>
    <h6 class="scorecard-details__label">Duration</h6>
    <span class="scorecard-details__value">{{ scorecard.duration }}</span>
  </div>
  <div>
    <h6 class="scorecard-details__label">Scorecard Template</h6>
    <span class="scorecard-details__value">{{ scorecard.scorecardName }}</span>
  </div>
  <div>
    <h6 class="scorecard-details__label">Scorecard Version</h6>
    <span class="scorecard-details__value">{{ scorecard.version }}</span>
  </div>
</div>

<h2 class="scorecard-title"> Scorecard Results </h2>

@for (section of scorecard.sections; track section.sectionName) {
  <table class="scorecard-table">
    <tr class="scorecard-table__header-row">
      <th>{{ section.sectionName }}</th>
      <th>Answer</th>
      <th>Points</th>
      <th>Challenge</th>
    </tr>
    @for (statement of section.statements; track statement.id) {
      @if (!statement.isHidden || showHiddenStatements) {
        <tr class="scorecard-table__row">
          <td>
            {{ statement | order: showHiddenStatements: statements }}. {{ statement.displayNameOrText }}
          </td>
          <td>
            <div class="scorecard-evaluation-status" [ngClass]="statement.evaluation.status === 'success' ? 'status-success' : 'status-fail'">
              {{ statement.evaluation.status | statusLabel }}
            </div>
          </td>
          <td>
           <span class="scorecard-points" [ngClass]="{'scorecard-points--success': statement.evaluation.status === 'success', 'scorecard-points--failed': statement.evaluation.status === 'fail'}">
             {{ statement.evaluation.status | scorePoints: statement.points }}
           </span>
          </td>
          <td><img alt="edit icon" src="/assets/icons/challenge-icon.svg" /></td>
        </tr>
      }
    }
  </table>
}
@if (!isLastScorecard) {
  <div class="html2pdf__page-break"></div>
}
